module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Add-user-15b96a014f5508ac088b2e2418d0e482.svg";